/* Transport and the secondary controls beside it. */

.transport {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tbtn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: var(--ink);
  transition:
    transform 0.22s var(--ease),
    background 0.2s;
}

.tbtn svg {
  width: 22px;
  height: 22px;
}

.tbtn:active {
  transform: scale(0.88);
}

@media (hover: hover) {
  .tbtn:hover {
    background: rgba(255, 255, 255, 0.6);
  }
}

.play {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #fff, #f2faf5);
  box-shadow:
    0 2px 10px rgba(16, 48, 34, 0.14),
    inset 0 0 0 0.5px rgba(255, 255, 255, 0.9);
  color: var(--accent-deep);
}

.play svg {
  width: 24px;
  height: 24px;
}

@media (hover: hover) {
  .play:hover {
    box-shadow:
      0 4px 16px rgba(16, 48, 34, 0.18),
      0 0 0 5px var(--accent-soft);
  }
}

.extras {
  display: flex;
  align-items: center;
  gap: 2px;
}

.xbtn {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: var(--ink-3);
  transition:
    color 0.2s,
    transform 0.22s var(--ease),
    background 0.2s;
}

.xbtn svg {
  width: 18px;
  height: 18px;
}

.xbtn:active {
  transform: scale(0.88);
}

.on {
  color: var(--accent-deep);
  background: var(--accent-soft);
}

.badge {
  position: absolute;
  bottom: 2px;
  right: 3px;
  font-size: 9px;
  font-weight: 700;
  background: var(--accent-deep);
  color: #fff;
  border-radius: 999px;
  padding: 0 3px;
  line-height: 12px;
}

.vol {
  display: flex;
  align-items: center;
  gap: 6px;
}

.volTrack {
  width: 62px;
  height: 5px;
  border-radius: 999px;
  background: rgba(11, 31, 23, 0.1);
  position: relative;
  cursor: pointer;
  touch-action: none;
}

/* A generous invisible hit area around a deliberately thin track. */
.volTrack::after {
  content: "";
  position: absolute;
  inset: -10px -6px;
}

.volFill {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--accent-deep), var(--accent));
}

@media (max-width: 620px) {
  .extras {
    display: none;
  }

  .tbtn {
    width: 38px;
    height: 38px;
  }

  .play {
    width: 46px;
    height: 46px;
  }
}
